// extracted by mini-css-extract-plugin
var _1 = "PageEmptyState-moduleactions___dBIy";
var _2 = "PageEmptyState-moduleicon__l165X IconNG-moduleiconContainer__SxWZ0";
var _3 = "PageEmptyState-modulepageEmptyState__X5n5M";
var _4 = "PageEmptyState-moduletext__b_Fm3";
export { _1 as "actions", _2 as "icon", _3 as "pageEmptyState", _4 as "text" }
